export default "#define GLSLIFY 1\nuniform vec3 uColor;\n\nvoid main() {\n  gl_FragColor = vec4(uColor.rgb, 1.0);\n}\n";